module.exports = __webpack_public_path__ + "media/images/icon_pause-29d2087615dbecd50605bc290073134e.png";